module.exports = __webpack_public_path__ + "media/images/icons/vendors/decorator-d1f0920b111d6b1b5eb5f94da91e4a35.png";